//Apresenta problema na alteração, pois os dados são mantidos

export default class {
    /*SEGUIR EXATAMENTE ESTE PADRÃO CHAMANDO form: new XXX(), POIS SE MUDAR DARÁ ERRO COM OBJETO NÃO SENDO ALTERADO A CADA INCLUSÃO*/

    constructor() {

        return {
            typePerson: 2,
            name: "",
            shortName: "",
            companyName: "",
            federalTaxpayer: "",
            otherPersonalDocument: "",
            provinceTaxpayer: "",
            provinceTaxpayerExempted: true,
            cityTaxpayer: "",
        }
    }

}
